import { render, staticRenderFns } from "./A-2-7_AboutUsEdit_VideoRotate.vue?vue&type=template&id=4daf2a53&"
import script from "./A-2-7_AboutUsEdit_VideoRotate.vue?vue&type=script&lang=js&"
export * from "./A-2-7_AboutUsEdit_VideoRotate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VRadio,VRadioGroup,VTextField})
